import {
  ChangePasswordDocs,
  ChangePasswordMachine,
} from './ChangePasswordMachine';
import { CreateMemberDocs, CreateMemberMachine } from './CreateMemberMachine';
import { GetMemberDocs, GetMemberMachine } from './GetMemberMachine';
import {
  GenerateTokenSmsDocs,
  GenerateTokenSmsMachine,
} from './GenerateTokenSmsMachine';
import { CountriesDocs, CountriesMachine } from './CountriesMachine';
import { ZipCodeDocs, ZipCodeMachine } from './ZipCodeMachine';
import {
  RecoverMemberNumberDocs,
  RecoverMemberNumberMachine,
} from './RecoverMemberNumberMachine';
import {
  ValidateDocumentDocs,
  ValidateDocumentMachine,
} from './ValidateDocumentMachine';
import {
  ValidateEmailDocs,
  ValidateEmailMachine,
} from './ValidateEmailRegisterMachine';
import {
  ValidateTokenSmsDocs,
  ValidateTokenSmsMachine,
} from './ValidateTokenSmsMachine';
import {
  ValidateTokenEmailDocs,
  ValidateTokenEmailMachine,
} from './ValidateTokenEmailMachine';
import {
  RecoverBigDataQuestionDocs,
  RecoverBigDataQuestionMachine,
} from './RecoverBigDataQuestionMachine';
import {
  ValidateBigDataQuestionDocs,
  ValidateBigDataQuestionMachine,
} from './ValidateBigDataQuestionMachine';
import { MemberInfoDocs, MemberInfoMachine } from './MemberInfoMachine';
import {
  MaskedContactDocs,
  MaskedContactMachine,
} from './MaskedContactMachine';
import { AccountIssueDocs, AccountIssueMachine } from './AccountIssueMachine';
import {
  ResetPasswordAccountIssueDocs,
  ResetPasswordAccountIssueMachine,
} from './ResetPasswordAccountIssueMachine';
import {
  ResetPasswordDocs,
  ResetPasswordMachine,
} from './ResetPasswordMachine';
import { UploadFileS3Docs, UploadFileS3Machine } from './UploadFileS3Machine';
import { MemberStatusDocs, MemberStatusMachine } from './MemberStatusMachine';

import { UpdateMemberMachine, UpdateMemberDocs } from './UpdateMemberMachine';

import {
  UpdateMemberSensitiveDataDocs,
  UpdateMemberSensitiveDataMachine,
} from './UpdateMemberSensitiveDataMachine';
import {
  ValidateLegalGuardianDocs,
  ValidateLegalGuardianMachine,
} from './ValidateLegalGuardianMachine';
import {
  GetDependentsDocs,
  GetDependentsMachine,
} from './GetDependentsMachine';
import {
  SendTokenEmailDocs,
  SendTokenEmailMachine,
} from './SendTokenEmailMachine';
import {
  CheckUpdateMemberStatusMachine,
  CheckUpdateMemberStatusDocs,
} from './CheckUpdateMemberStatusMachine';
import { GenericTypes } from '_core/domain/Utils/Generic/Types';

const onChangePassword: GenericTypes = {
  machine: ChangePasswordMachine,
  docs: ChangePasswordDocs,
  order: 1,
};

const onGenerateTokenSms: GenericTypes = {
  machine: GenerateTokenSmsMachine,
  docs: GenerateTokenSmsDocs,
  order: 1,
};

const onGetListCountry: GenericTypes = {
  machine: CountriesMachine,
  docs: CountriesDocs,
  order: 1,
};

const onRecoverMemberNumber: GenericTypes = {
  machine: RecoverMemberNumberMachine,
  docs: RecoverMemberNumberDocs,
  order: 1,
};

const onValidateEmail: GenericTypes = {
  machine: ValidateEmailMachine,
  docs: ValidateEmailDocs,
  order: 1,
};

const onValidateTokenSms: GenericTypes = {
  machine: ValidateTokenSmsMachine,
  docs: ValidateTokenSmsDocs,
  order: 1,
};

const onValidateTokenEmail: GenericTypes = {
  machine: ValidateTokenEmailMachine,
  docs: ValidateTokenEmailDocs,
  order: 1,
};

const onRecoverBigDataQuestion: GenericTypes = {
  machine: RecoverBigDataQuestionMachine,
  docs: RecoverBigDataQuestionDocs,
  order: 1,
};

const onValidateBigDataQuestion: GenericTypes = {
  machine: ValidateBigDataQuestionMachine,
  docs: ValidateBigDataQuestionDocs,
  order: 1,
};

const onMemberInfo: GenericTypes = {
  machine: MemberInfoMachine,
  docs: MemberInfoDocs,
  order: 1,
};

const onMaskedContact: GenericTypes = {
  machine: MaskedContactMachine,
  docs: MaskedContactDocs,
  order: 1,
};

const onAccountIssue: GenericTypes = {
  machine: AccountIssueMachine,
  docs: AccountIssueDocs,
  order: 1,
};

const onResetPasswordAccountIssue: GenericTypes = {
  machine: ResetPasswordAccountIssueMachine,
  docs: ResetPasswordAccountIssueDocs,
  order: 1,
};

const onResetPassword: GenericTypes = {
  machine: ResetPasswordMachine,
  docs: ResetPasswordDocs,
  order: 1,
};
const onUploadFileS3: GenericTypes = {
  machine: UploadFileS3Machine,
  docs: UploadFileS3Docs,
  order: 1,
};
const onMemberStatus: GenericTypes = {
  machine: MemberStatusMachine,
  docs: MemberStatusDocs,
  order: 1,
};

const onCreateMember: GenericTypes = {
  machine: CreateMemberMachine,
  docs: CreateMemberDocs,
  order: 1,
};

const onGetMember: GenericTypes = {
  machine: GetMemberMachine,
  docs: GetMemberDocs,
  order: 1,
};

const onUpdateMember: GenericTypes = {
  machine: UpdateMemberMachine,
  docs: UpdateMemberDocs,
  order: 1,
};

const onUpdateMemberSensitiveData: GenericTypes = {
  machine: UpdateMemberSensitiveDataMachine,
  docs: UpdateMemberSensitiveDataDocs,
  order: 1,
};
const onValidateLegalGuardian: GenericTypes = {
  machine: ValidateLegalGuardianMachine,
  docs: ValidateLegalGuardianDocs,
  order: 1,
};
const onGetDependents: GenericTypes = {
  machine: GetDependentsMachine,
  docs: GetDependentsDocs,
  order: 1,
};
const onSendTokenEmail: GenericTypes = {
  machine: SendTokenEmailMachine,
  docs: SendTokenEmailDocs,
  order: 1,
};

const onGetZipCode: GenericTypes = {
  machine: ZipCodeMachine,
  docs: ZipCodeDocs,
  order: 1,
};

const onValidateDocument: GenericTypes = {
  machine: ValidateDocumentMachine,
  docs: ValidateDocumentDocs,
  order: 1,
};

const onCheckUpdateMemberStatus: GenericTypes = {
  machine: CheckUpdateMemberStatusMachine,
  docs: CheckUpdateMemberStatusDocs,
  order: 1,
};

export default {
  onChangePassword,
  onCreateMember,
  onGenerateTokenSms,
  onGetListCountry,
  onGetMember,
  onGetZipCode,
  onRecoverMemberNumber,
  onValidateDocument,
  onValidateEmail,
  onValidateTokenSms,
  onValidateTokenEmail,
  onRecoverBigDataQuestion,
  onValidateBigDataQuestion,
  onMemberInfo,
  onMaskedContact,
  onAccountIssue,
  onResetPasswordAccountIssue,
  onResetPassword,
  onUpdateMember,
  onUpdateMemberSensitiveData,
  onUploadFileS3,
  onMemberStatus,
  onValidateLegalGuardian,
  onGetDependents,
  onSendTokenEmail,
  onCheckUpdateMemberStatus,
};
